var map = {
	"./architecture.png": "0c99",
	"./clothing.png": "843d",
	"./consumer_electronics.png": "9c74",
	"./furniture.png": "d692",
	"./hand_bags.png": "4a01",
	"./sunglasses.png": "e64d",
	"./transportation.png": "f1d6",
	"./watches.png": "3f66"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8267";